export const initialValues = {
  name: "",
  is_active: 0,
  isDefault: 0,
};
